import { useEffect, useState, useRef } from 'react'
import { supabase } from '../supabaseClient'
import Button from 'react-bootstrap/Button'
import { PersonAdd } from 'react-bootstrap-icons';
import Image from 'react-bootstrap/Image';

export default function Avatar({ url, size, onUpload }) {
  const [avatarUrl, setAvatarUrl] = useState(null)
  const [uploading, setUploading] = useState(false)

  useEffect(() => {
    if (url) downloadImage(url)
  }, [url])

  async function downloadImage(path) {
    try {
      const { data, error } = await supabase.storage.from('avatars').download(path)
      if (error) {
        throw error
      }
      const url = URL.createObjectURL(data)
      setAvatarUrl(url)
    } catch (error) {
      console.log('Error downloading image: ', error.message)
    }
  }

  async function uploadAvatar(event) {
    try {
      setUploading(true)

      if (!event.target.files || event.target.files.length === 0) {
        throw new Error('You must select an image to upload.')
      }

      const file = event.target.files[0]
      const fileExt = file.name.split('.').pop()
      const fileName = `${Math.random()}.${fileExt}`
      const filePath = `${fileName}`

      const { error: uploadError } = await supabase.storage.from('avatars').upload(filePath, file)

      if (uploadError) {
        throw uploadError
      }

      onUpload(event, filePath)
    } catch (error) {
      alert(error.message)
    } finally {
      setUploading(false)
    }
  }

  const inputRef = useRef(null);
   
  const handleUploadFile = () => {
    inputRef.current?.click();
  };

  return (
    <div class="d-flex flex-row justify-content-center align-items-center">
      {avatarUrl ? (
        <Image
          src={avatarUrl} roundedCircle
          alt="Avatar"
          className="avatar image"
          style={{ height: size, width: size }}
            onClick={handleUploadFile}
        />
      ) : (
        <></>
      )}
      <div >
        <input
          ref={inputRef}
          style={{
            visibility: 'hidden',
            position: 'absolute',
          }}
          type="file"
          id="single"
          accept="image/*"
          onChange={uploadAvatar}
          disabled={uploading}
        />
        {uploading ?'Uploading ...' :null}
        <Button size="sm" variant="ghost-primary" onClick={handleUploadFile} >{!uploading && !avatarUrl ? (<PersonAdd size={32}/>) : null}</Button>
      </div>
    </div>
  )
}